<template>
  <section>
    <div class="intro-holder">
      <h1>Welkom bij {{ rootStore.theme.printStore.name }} Signing</h1>
      <p>
        Uw eigen logo of ontwerpen toevoegen?
      </p>
      <button class="pill-button" @click="showForm">Klik hier</button>
      <div class="dummies">
        <div class="dummy" @click="showForm">
          <p>?</p>
          <div class="text">Uw eigen logo<br />of ontwerp</div>
        </div>
        <div class="dummy" @click="showForm">
          <p>?</p>
          <div class="text">Uw eigen logo<br />of ontwerp</div>
        </div>
        <div class="dummy" @click="showForm">
          <p>?</p>
          <div class="text">Uw eigen logo<br />of ontwerp</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { he } from 'date-fns/locale'
import ProductRequest from '../dialogs/CustomPrintStoreRequest'

export default {
  data() {
    return {}
  },
  components: { ProductRequest },
  methods: {
    showForm() {
      this.$modal.show(ProductRequest, {}, { width: 380, height: 'auto' })
    }
  }
}
</script>

<style lang="scss" scoped>
.intro-holder {
  padding: 80px 20px 0;
  margin: 0 auto;
  text-align: center;
}

h1 {
  font-size: 19px;
  font-weight: 500;
  color: var(--sub-color);
}

p {
  padding-bottom: 20px;
}

.pill-button {
  padding-left: 40px;
  padding-right: 40px;
}

.dummies {
  display: flex;
  margin-top: 60px;
  justify-content: center;
  flex-wrap: wrap;
}

.dummy {
  width: 191px;
  height: 274px;
  border-radius: 24px;
  box-shadow: rgba(0, 0, 0, 0.5) 0 0 28px -16px;
  padding: 4px;
  cursor: pointer;
  margin-bottom: 25px;

  &:nth-child(2) {
    margin: 0 25px;
  }

  p {
    padding: 0;
    height: 182px;
    line-height: 182px;
    font-size: 100px;
    font-weight: 500;
  }
}

.text {
  height: 84px;
  text-align: center;
  background: #f4f4f4;
  border-radius: 20px;
  font-weight: 500;
  padding-top: 23px;
}
</style>
